var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlkimaErfolgsgeschichteBwOnlineShopRaketeStartSterne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 446,
    viewBox: "0 0 164 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.1 105.3C72.5146 105.3 84.2 93.6142 84.2 79.1996C84.2 64.785 72.5146 53.0996 58.1 53.0996C43.6854 53.0996 32 64.785 32 79.1996C32 93.6142 43.6854 105.3 58.1 105.3Z",
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.1008 94.5004C66.5507 94.5004 73.4008 87.6503 73.4008 79.2004C73.4008 70.7504 66.5507 63.9004 58.1008 63.9004C49.6508 63.9004 42.8008 70.7504 42.8008 79.2004C42.8008 87.6503 49.6508 94.5004 58.1008 94.5004Z",
    fill: "url(#paint1_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.1008 89.0004C63.5132 89.0004 67.9008 84.6128 67.9008 79.2004C67.9008 73.788 63.5132 69.4004 58.1008 69.4004C52.6884 69.4004 48.3008 73.788 48.3008 79.2004C48.3008 84.6128 52.6884 89.0004 58.1008 89.0004Z",
    fill: "url(#paint2_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.9008 79.2004C63.9008 82.4004 61.3008 85.0004 58.1008 85.0004C54.9008 85.0004 52.3008 82.4004 52.3008 79.2004C52.3008 76.0004 54.9008 73.4004 58.1008 73.4004C61.3008 73.4004 63.9008 76.0004 63.9008 79.2004Z",
    fill: "url(#paint3_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.6016 79.9995H57.6016V388.999H58.6016V79.9995Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6016 79.4995C56.6016 80.3567 57.2444 80.9995 58.1015 80.9995C58.9587 80.9995 59.6016 80.3567 59.6016 79.4995C59.6016 78.6424 58.9587 77.9995 58.1015 77.9995C57.2444 78.1067 56.6016 78.7495 56.6016 79.4995Z",
    fill: "url(#paint5_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.1 135.2C50.5146 135.2 62.2 123.515 62.2 109.1C62.2 94.6854 50.5146 83 36.1 83C21.6854 83 10 94.6854 10 109.1C10 123.515 21.6854 135.2 36.1 135.2Z",
    fill: "url(#paint6_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.1008 124.401C44.5507 124.401 51.4008 117.551 51.4008 109.101C51.4008 100.651 44.5507 93.8008 36.1008 93.8008C27.6508 93.8008 20.8008 100.651 20.8008 109.101C20.8008 117.551 27.6508 124.401 36.1008 124.401Z",
    fill: "url(#paint7_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.1008 118.901C41.5132 118.901 45.9008 114.513 45.9008 109.101C45.9008 103.688 41.5132 99.3008 36.1008 99.3008C30.6884 99.3008 26.3008 103.688 26.3008 109.101C26.3008 114.513 30.6884 118.901 36.1008 118.901Z",
    fill: "url(#paint8_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41.9008 109.101C41.9008 112.301 39.3008 114.901 36.1008 114.901C32.9008 114.901 30.3008 112.301 30.3008 109.101C30.3008 105.901 32.9008 103.301 36.1008 103.301C39.3008 103.301 41.9008 105.901 41.9008 109.101Z",
    fill: "url(#paint9_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.6016 109.9H35.6016V418.9H36.6016V109.9Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6016 109.4C34.6016 110.257 35.2444 110.9 36.1015 110.9C36.9587 110.9 37.6016 110.257 37.6016 109.4C37.6016 108.543 36.9587 107.9 36.1015 107.9C35.2444 108.007 34.6016 108.65 34.6016 109.4Z",
    fill: "url(#paint11_linear)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.1 52.2C118.515 52.2 130.2 40.5146 130.2 26.1C130.2 11.6854 118.515 0 104.1 0C89.6854 0 78 11.6854 78 26.1C78 40.5146 89.6854 52.2 104.1 52.2Z",
    fill: "url(#paint12_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.101 41.4008C112.551 41.4008 119.401 34.5507 119.401 26.1008C119.401 17.6508 112.551 10.8008 104.101 10.8008C95.6508 10.8008 88.8008 17.6508 88.8008 26.1008C88.8008 34.5507 95.6508 41.4008 104.101 41.4008Z",
    fill: "url(#paint13_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.101 35.9008C109.513 35.9008 113.901 31.5132 113.901 26.1008C113.901 20.6884 109.513 16.3008 104.101 16.3008C98.6884 16.3008 94.3008 20.6884 94.3008 26.1008C94.3008 31.5132 98.6884 35.9008 104.101 35.9008Z",
    fill: "url(#paint14_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.901 26.1008C109.901 29.3008 107.301 31.9008 104.101 31.9008C100.901 31.9008 98.3008 29.3008 98.3008 26.1008C98.3008 22.9008 100.901 20.3008 104.101 20.3008C107.301 20.3008 109.901 22.9008 109.901 26.1008Z",
    fill: "url(#paint15_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.602 26.8999H103.602V335.9H104.602V26.8999Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.602 26.3999C102.602 27.2571 103.244 27.8999 104.102 27.8999C104.959 27.8999 105.602 27.2571 105.602 26.3999C105.602 25.5428 104.959 24.8999 104.102 24.8999C103.244 25.007 102.602 25.6499 102.602 26.3999Z",
    fill: "url(#paint17_linear)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M117.1 251.2C131.515 251.2 143.2 239.515 143.2 225.1C143.2 210.685 131.515 199 117.1 199C102.685 199 91 210.685 91 225.1C91 239.515 102.685 251.2 117.1 251.2Z",
    fill: "url(#paint18_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M117.101 240.4C125.551 240.4 132.401 233.55 132.401 225.1C132.401 216.65 125.551 209.8 117.101 209.8C108.651 209.8 101.801 216.65 101.801 225.1C101.801 233.55 108.651 240.4 117.101 240.4Z",
    fill: "url(#paint19_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M117.101 234.9C122.513 234.9 126.901 230.512 126.901 225.1C126.901 219.687 122.513 215.3 117.101 215.3C111.688 215.3 107.301 219.687 107.301 225.1C107.301 230.512 111.688 234.9 117.101 234.9Z",
    fill: "url(#paint20_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.901 225.1C122.901 228.3 120.301 230.9 117.101 230.9C113.901 230.9 111.301 228.3 111.301 225.1C111.301 221.9 113.901 219.3 117.101 219.3C120.301 219.3 122.901 221.9 122.901 225.1Z",
    fill: "url(#paint21_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M118 226H117V321H118V226Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.602 225.4C115.602 226.257 116.244 226.9 117.102 226.9C117.959 226.9 118.602 226.257 118.602 225.4C118.602 224.543 117.959 223.9 117.102 223.9C116.244 224.007 115.602 224.65 115.602 225.4Z",
    fill: "url(#paint23_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.1 161.2C143.515 161.2 155.2 149.515 155.2 135.1C155.2 120.685 143.515 109 129.1 109C114.685 109 103 120.685 103 135.1C103 149.515 114.685 161.2 129.1 161.2Z",
    fill: "url(#paint24_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.101 150.4C137.551 150.4 144.401 143.55 144.401 135.1C144.401 126.65 137.551 119.8 129.101 119.8C120.651 119.8 113.801 126.65 113.801 135.1C113.801 143.55 120.651 150.4 129.101 150.4Z",
    fill: "url(#paint25_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.101 144.9C134.513 144.9 138.901 140.512 138.901 135.1C138.901 129.687 134.513 125.3 129.101 125.3C123.688 125.3 119.301 129.687 119.301 135.1C119.301 140.512 123.688 144.9 129.101 144.9Z",
    fill: "url(#paint26_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134.901 135.1C134.901 138.3 132.301 140.9 129.101 140.9C125.901 140.9 123.301 138.3 123.301 135.1C123.301 131.9 125.901 129.3 129.101 129.3C132.301 129.3 134.901 131.9 134.901 135.1Z",
    fill: "url(#paint27_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130 136H129V410H130V136Z",
    fill: "url(#paint28_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 135.4C128 136.257 128.643 136.9 129.5 136.9C130.357 136.9 131 136.257 131 135.4C131 134.543 130.357 133.9 129.5 133.9C128.643 134.007 128 134.65 128 135.4Z",
    fill: "url(#paint29_linear)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1 215.2C79.5146 215.2 91.2 203.515 91.2 189.1C91.2 174.685 79.5146 163 65.1 163C50.6854 163 39 174.685 39 189.1C39 203.515 50.6854 215.2 65.1 215.2Z",
    fill: "url(#paint30_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1008 204.4C73.5507 204.4 80.4008 197.55 80.4008 189.1C80.4008 180.65 73.5507 173.8 65.1008 173.8C56.6508 173.8 49.8008 180.65 49.8008 189.1C49.8008 197.55 56.6508 204.4 65.1008 204.4Z",
    fill: "url(#paint31_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.1008 198.9C70.5132 198.9 74.9008 194.512 74.9008 189.1C74.9008 183.687 70.5132 179.3 65.1008 179.3C59.6884 179.3 55.3008 183.687 55.3008 189.1C55.3008 194.512 59.6884 198.9 65.1008 198.9Z",
    fill: "url(#paint32_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M70.9008 189.1C70.9008 192.3 68.3008 194.9 65.1008 194.9C61.9008 194.9 59.3008 192.3 59.3008 189.1C59.3008 185.9 61.9008 183.3 65.1008 183.3C68.3008 183.3 70.9008 185.9 70.9008 189.1Z",
    fill: "url(#paint33_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66 190H65V383H66V190Z",
    fill: "url(#paint34_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 189.4C64 190.257 64.6428 190.9 65.5 190.9C66.3571 190.9 67 190.257 67 189.4C67 188.543 66.3571 187.9 65.5 187.9C64.6428 188.007 64 188.65 64 189.4Z",
    fill: "url(#paint35_linear)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.1 166.2C61.5146 166.2 73.2 154.515 73.2 140.1C73.2 125.685 61.5146 114 47.1 114C32.6854 114 21 125.685 21 140.1C21 154.515 32.6854 166.2 47.1 166.2Z",
    fill: "url(#paint36_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.1008 155.4C55.5507 155.4 62.4008 148.55 62.4008 140.1C62.4008 131.65 55.5507 124.8 47.1008 124.8C38.6508 124.8 31.8008 131.65 31.8008 140.1C31.8008 148.55 38.6508 155.4 47.1008 155.4Z",
    fill: "url(#paint37_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.1008 149.9C52.5132 149.9 56.9008 145.512 56.9008 140.1C56.9008 134.687 52.5132 130.3 47.1008 130.3C41.6884 130.3 37.3008 134.687 37.3008 140.1C37.3008 145.512 41.6884 149.9 47.1008 149.9Z",
    fill: "url(#paint38_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.9008 140.1C52.9008 143.3 50.3008 145.9 47.1008 145.9C43.9008 145.9 41.3008 143.3 41.3008 140.1C41.3008 136.9 43.9008 134.3 47.1008 134.3C50.3008 134.3 52.9008 136.9 52.9008 140.1Z",
    fill: "url(#paint39_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M48 141H47V385H48V141Z",
    fill: "url(#paint40_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 140.5C46 141.357 46.6428 142 47.5 142C48.3571 142 49 141.357 49 140.5C49 139.643 48.3571 139 47.5 139C46.6428 139.107 46 139.75 46 140.5Z",
    fill: "url(#paint41_linear)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.1 184.2C42.5146 184.2 54.2 172.515 54.2 158.1C54.2 143.685 42.5146 132 28.1 132C13.6854 132 2 143.685 2 158.1C2 172.515 13.6854 184.2 28.1 184.2Z",
    fill: "url(#paint42_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.1008 173.4C36.5507 173.4 43.4008 166.55 43.4008 158.1C43.4008 149.65 36.5507 142.8 28.1008 142.8C19.6508 142.8 12.8008 149.65 12.8008 158.1C12.8008 166.55 19.6508 173.4 28.1008 173.4Z",
    fill: "url(#paint43_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.1008 167.9C33.5132 167.9 37.9008 163.512 37.9008 158.1C37.9008 152.687 33.5132 148.3 28.1008 148.3C22.6884 148.3 18.3008 152.687 18.3008 158.1C18.3008 163.512 22.6884 167.9 28.1008 167.9Z",
    fill: "url(#paint44_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.9008 158.1C33.9008 161.3 31.3008 163.9 28.1008 163.9C24.9008 163.9 22.3008 161.3 22.3008 158.1C22.3008 154.9 24.9008 152.3 28.1008 152.3C31.3008 152.3 33.9008 154.9 33.9008 158.1Z",
    fill: "url(#paint45_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29 159H28V403H29V159Z",
    fill: "url(#paint46_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 158.5C27 159.357 27.6428 160 28.5 160C29.3571 160 30 159.357 30 158.5C30 157.643 29.3571 157 28.5 157C27.6428 157.107 27 157.75 27 158.5Z",
    fill: "url(#paint47_linear)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.1 227.2C53.5146 227.2 65.2 215.515 65.2 201.1C65.2 186.685 53.5146 175 39.1 175C24.6854 175 13 186.685 13 201.1C13 215.515 24.6854 227.2 39.1 227.2Z",
    fill: "url(#paint48_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.1008 216.4C47.5507 216.4 54.4008 209.55 54.4008 201.1C54.4008 192.65 47.5507 185.8 39.1008 185.8C30.6508 185.8 23.8008 192.65 23.8008 201.1C23.8008 209.55 30.6508 216.4 39.1008 216.4Z",
    fill: "url(#paint49_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.1008 210.9C44.5132 210.9 48.9008 206.512 48.9008 201.1C48.9008 195.687 44.5132 191.3 39.1008 191.3C33.6884 191.3 29.3008 195.687 29.3008 201.1C29.3008 206.512 33.6884 210.9 39.1008 210.9Z",
    fill: "url(#paint50_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.9008 201.1C44.9008 204.3 42.3008 206.9 39.1008 206.9C35.9008 206.9 33.3008 204.3 33.3008 201.1C33.3008 197.9 35.9008 195.3 39.1008 195.3C42.3008 195.3 44.9008 197.9 44.9008 201.1Z",
    fill: "url(#paint51_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40 202H39V446H40V202Z",
    fill: "url(#paint52_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 201.5C38 202.357 38.6428 203 39.5 203C40.3571 203 41 202.357 41 201.5C41 200.643 40.3571 200 39.5 200C38.6428 200.107 38 200.75 38 201.5Z",
    fill: "url(#paint53_linear)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.1 92.2C40.5146 92.2 52.2 80.5146 52.2 66.1C52.2 51.6854 40.5146 40 26.1 40C11.6854 40 0 51.6854 0 66.1C0 80.5146 11.6854 92.2 26.1 92.2Z",
    fill: "url(#paint54_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.1008 81.3998C34.5507 81.3998 41.4008 74.5498 41.4008 66.0998C41.4008 57.6498 34.5507 50.7998 26.1008 50.7998C17.6508 50.7998 10.8008 57.6498 10.8008 66.0998C10.8008 74.5498 17.6508 81.3998 26.1008 81.3998Z",
    fill: "url(#paint55_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.1008 75.8998C31.5132 75.8998 35.9008 71.5122 35.9008 66.0998C35.9008 60.6874 31.5132 56.2998 26.1008 56.2998C20.6884 56.2998 16.3008 60.6874 16.3008 66.0998C16.3008 71.5122 20.6884 75.8998 26.1008 75.8998Z",
    fill: "url(#paint56_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.9008 66.0998C31.9008 69.2998 29.3008 71.8998 26.1008 71.8998C22.9008 71.8998 20.3008 69.2998 20.3008 66.0998C20.3008 62.8998 22.9008 60.2998 26.1008 60.2998C29.3008 60.2998 31.9008 62.8998 31.9008 66.0998Z",
    fill: "url(#paint57_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27 67H26V311H27V67Z",
    fill: "url(#paint58_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 66.5C25 67.3571 25.6428 68 26.5 68C27.3571 68 28 67.3571 28 66.5C28 65.6429 27.3571 65 26.5 65C25.6428 65.1071 25 65.75 25 66.5Z",
    fill: "url(#paint59_linear)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.1 190.2C137.515 190.2 149.2 178.515 149.2 164.1C149.2 149.685 137.515 138 123.1 138C108.685 138 97 149.685 97 164.1C97 178.515 108.685 190.2 123.1 190.2Z",
    fill: "url(#paint60_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.101 179.4C131.551 179.4 138.401 172.55 138.401 164.1C138.401 155.65 131.551 148.8 123.101 148.8C114.651 148.8 107.801 155.65 107.801 164.1C107.801 172.55 114.651 179.4 123.101 179.4Z",
    fill: "url(#paint61_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M123.101 173.9C128.513 173.9 132.901 169.512 132.901 164.1C132.901 158.687 128.513 154.3 123.101 154.3C117.688 154.3 113.301 158.687 113.301 164.1C113.301 169.512 117.688 173.9 123.101 173.9Z",
    fill: "url(#paint62_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M128.901 164.1C128.901 167.3 126.301 169.9 123.101 169.9C119.901 169.9 117.301 167.3 117.301 164.1C117.301 160.9 119.901 158.3 123.101 158.3C126.301 158.3 128.901 160.9 128.901 164.1Z",
    fill: "url(#paint63_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124 165H123V409H124V165Z",
    fill: "url(#paint64_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 164.5C122 165.357 122.643 166 123.5 166C124.357 166 125 165.357 125 164.5C125 163.643 124.357 163 123.5 163C122.643 163.107 122 163.75 122 164.5Z",
    fill: "url(#paint65_linear)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99.1 105.2C113.515 105.2 125.2 93.5146 125.2 79.1C125.2 64.6854 113.515 53 99.1 53C84.6854 53 73 64.6854 73 79.1C73 93.5146 84.6854 105.2 99.1 105.2Z",
    fill: "url(#paint66_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99.1008 94.3998C107.551 94.3998 114.401 87.5498 114.401 79.0998C114.401 70.6498 107.551 63.7998 99.1008 63.7998C90.6508 63.7998 83.8008 70.6498 83.8008 79.0998C83.8008 87.5498 90.6508 94.3998 99.1008 94.3998Z",
    fill: "url(#paint67_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M99.1008 88.8998C104.513 88.8998 108.901 84.5122 108.901 79.0998C108.901 73.6874 104.513 69.2998 99.1008 69.2998C93.6884 69.2998 89.3008 73.6874 89.3008 79.0998C89.3008 84.5122 93.6884 88.8998 99.1008 88.8998Z",
    fill: "url(#paint68_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.901 79.0998C104.901 82.2998 102.301 84.8998 99.1008 84.8998C95.9008 84.8998 93.3008 82.2998 93.3008 79.0998C93.3008 75.8998 95.9008 73.2998 99.1008 73.2998C102.301 73.2998 104.901 75.8998 104.901 79.0998Z",
    fill: "url(#paint69_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M100 80H99V324H100V80Z",
    fill: "url(#paint70_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 79.5C98 80.3571 98.6428 81 99.5 81C100.357 81 101 80.3571 101 79.5C101 78.6429 100.357 78 99.5 78C98.6428 78.1071 98 78.75 98 79.5Z",
    fill: "url(#paint71_linear)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.1 256.2C93.5146 256.2 105.2 244.515 105.2 230.1C105.2 215.685 93.5146 204 79.1 204C64.6854 204 53 215.685 53 230.1C53 244.515 64.6854 256.2 79.1 256.2Z",
    fill: "url(#paint72_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.1008 245.4C87.5507 245.4 94.4008 238.55 94.4008 230.1C94.4008 221.65 87.5507 214.8 79.1008 214.8C70.6508 214.8 63.8008 221.65 63.8008 230.1C63.8008 238.55 70.6508 245.4 79.1008 245.4Z",
    fill: "url(#paint73_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.1008 239.9C84.5132 239.9 88.9008 235.512 88.9008 230.1C88.9008 224.687 84.5132 220.3 79.1008 220.3C73.6884 220.3 69.3008 224.687 69.3008 230.1C69.3008 235.512 73.6884 239.9 79.1008 239.9Z",
    fill: "url(#paint74_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.9008 230.1C84.9008 233.3 82.3008 235.9 79.1008 235.9C75.9008 235.9 73.3008 233.3 73.3008 230.1C73.3008 226.9 75.9008 224.3 79.1008 224.3C82.3008 224.3 84.9008 226.9 84.9008 230.1Z",
    fill: "url(#paint75_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80 231H79V334H80V231Z",
    fill: "url(#paint76_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 230.5C78 231.357 78.6428 232 79.5 232C80.3571 232 81 231.357 81 230.5C81 229.643 80.3571 229 79.5 229C78.6428 229.107 78 229.75 78 230.5Z",
    fill: "url(#paint77_linear)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.1 167.2C100.515 167.2 112.2 155.515 112.2 141.1C112.2 126.685 100.515 115 86.1 115C71.6854 115 60 126.685 60 141.1C60 155.515 71.6854 167.2 86.1 167.2Z",
    fill: "url(#paint78_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.1008 156.4C94.5507 156.4 101.401 149.55 101.401 141.1C101.401 132.65 94.5507 125.8 86.1008 125.8C77.6508 125.8 70.8008 132.65 70.8008 141.1C70.8008 149.55 77.6508 156.4 86.1008 156.4Z",
    fill: "url(#paint79_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.1008 150.9C91.5132 150.9 95.9008 146.512 95.9008 141.1C95.9008 135.687 91.5132 131.3 86.1008 131.3C80.6884 131.3 76.3008 135.687 76.3008 141.1C76.3008 146.512 80.6884 150.9 86.1008 150.9Z",
    fill: "url(#paint80_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.9008 141.1C91.9008 144.3 89.3008 146.9 86.1008 146.9C82.9008 146.9 80.3008 144.3 80.3008 141.1C80.3008 137.9 82.9008 135.3 86.1008 135.3C89.3008 135.3 91.9008 137.9 91.9008 141.1Z",
    fill: "url(#paint81_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M87 142H86V386H87V142Z",
    fill: "url(#paint82_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 141.5C85 142.357 85.6428 143 86.5 143C87.3571 143 88 142.357 88 141.5C88 140.643 87.3571 140 86.5 140C85.6428 140.107 85 140.75 85 141.5Z",
    fill: "url(#paint83_linear)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.1 304.2C109.515 304.2 121.2 292.515 121.2 278.1C121.2 263.685 109.515 252 95.1 252C80.6854 252 69 263.685 69 278.1C69 292.515 80.6854 304.2 95.1 304.2Z",
    fill: "url(#paint84_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.1008 293.4C103.551 293.4 110.401 286.55 110.401 278.1C110.401 269.65 103.551 262.8 95.1008 262.8C86.6508 262.8 79.8008 269.65 79.8008 278.1C79.8008 286.55 86.6508 293.4 95.1008 293.4Z",
    fill: "url(#paint85_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M95.1008 287.9C100.513 287.9 104.901 283.512 104.901 278.1C104.901 272.687 100.513 268.3 95.1008 268.3C89.6884 268.3 85.3008 272.687 85.3008 278.1C85.3008 283.512 89.6884 287.9 95.1008 287.9Z",
    fill: "url(#paint86_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M100.901 278.1C100.901 281.3 98.3008 283.9 95.1008 283.9C91.9008 283.9 89.3008 281.3 89.3008 278.1C89.3008 274.9 91.9008 272.3 95.1008 272.3C98.3008 272.3 100.901 274.9 100.901 278.1Z",
    fill: "url(#paint87_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96 279H95V379H96V279Z",
    fill: "url(#paint88_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 278.5C94 279.357 94.6428 280 95.5 280C96.3571 280 97 279.357 97 278.5C97 277.643 96.3571 277 95.5 277C94.6428 277.107 94 277.75 94 278.5Z",
    fill: "url(#paint89_linear)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.1 308.2C138.515 308.2 150.2 296.515 150.2 282.1C150.2 267.685 138.515 256 124.1 256C109.685 256 98 267.685 98 282.1C98 296.515 109.685 308.2 124.1 308.2Z",
    fill: "url(#paint90_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.101 297.4C132.551 297.4 139.401 290.55 139.401 282.1C139.401 273.65 132.551 266.8 124.101 266.8C115.651 266.8 108.801 273.65 108.801 282.1C108.801 290.55 115.651 297.4 124.101 297.4Z",
    fill: "url(#paint91_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.101 291.9C129.513 291.9 133.901 287.512 133.901 282.1C133.901 276.687 129.513 272.3 124.101 272.3C118.688 272.3 114.301 276.687 114.301 282.1C114.301 287.512 118.688 291.9 124.101 291.9Z",
    fill: "url(#paint92_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.901 282.1C129.901 285.3 127.301 287.9 124.101 287.9C120.901 287.9 118.301 285.3 118.301 282.1C118.301 278.9 120.901 276.3 124.101 276.3C127.301 276.3 129.901 278.9 129.901 282.1Z",
    fill: "url(#paint93_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125 283H124V354H125V283Z",
    fill: "url(#paint94_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 282.5C123 283.357 123.643 284 124.5 284C125.357 284 126 283.357 126 282.5C126 281.643 125.357 281 124.5 281C123.643 281.107 123 281.75 123 282.5Z",
    fill: "url(#paint95_linear)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.1 367.2C73.5146 367.2 85.2 355.515 85.2 341.1C85.2 326.685 73.5146 315 59.1 315C44.6854 315 33 326.685 33 341.1C33 355.515 44.6854 367.2 59.1 367.2Z",
    fill: "url(#paint96_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.1008 356.4C67.5507 356.4 74.4008 349.55 74.4008 341.1C74.4008 332.65 67.5507 325.8 59.1008 325.8C50.6508 325.8 43.8008 332.65 43.8008 341.1C43.8008 349.55 50.6508 356.4 59.1008 356.4Z",
    fill: "url(#paint97_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.1008 350.9C64.5132 350.9 68.9008 346.512 68.9008 341.1C68.9008 335.687 64.5132 331.3 59.1008 331.3C53.6884 331.3 49.3008 335.687 49.3008 341.1C49.3008 346.512 53.6884 350.9 59.1008 350.9Z",
    fill: "url(#paint98_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.9008 341.1C64.9008 344.3 62.3008 346.9 59.1008 346.9C55.9008 346.9 53.3008 344.3 53.3008 341.1C53.3008 337.9 55.9008 335.3 59.1008 335.3C62.3008 335.3 64.9008 337.9 64.9008 341.1Z",
    fill: "url(#paint99_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60 342H59V389H60V342Z",
    fill: "url(#paint100_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 341.5C58 342.357 58.6428 343 59.5 343C60.3571 343 61 342.357 61 341.5C61 340.643 60.3571 340 59.5 340C58.6428 340.107 58 340.75 58 341.5Z",
    fill: "url(#paint101_linear)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M102.1 377.2C116.515 377.2 128.2 365.515 128.2 351.1C128.2 336.685 116.515 325 102.1 325C87.6854 325 76 336.685 76 351.1C76 365.515 87.6854 377.2 102.1 377.2Z",
    fill: "url(#paint102_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M102.101 366.4C110.551 366.4 117.401 359.55 117.401 351.1C117.401 342.65 110.551 335.8 102.101 335.8C93.6508 335.8 86.8008 342.65 86.8008 351.1C86.8008 359.55 93.6508 366.4 102.101 366.4Z",
    fill: "url(#paint103_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M102.101 360.9C107.513 360.9 111.901 356.512 111.901 351.1C111.901 345.687 107.513 341.3 102.101 341.3C96.6884 341.3 92.3008 345.687 92.3008 351.1C92.3008 356.512 96.6884 360.9 102.101 360.9Z",
    fill: "url(#paint104_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.901 351.1C107.901 354.3 105.301 356.9 102.101 356.9C98.9008 356.9 96.3008 354.3 96.3008 351.1C96.3008 347.9 98.9008 345.3 102.101 345.3C105.301 345.3 107.901 347.9 107.901 351.1Z",
    fill: "url(#paint105_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103 352H102V377H103V352Z",
    fill: "url(#paint106_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 351.5C101 352.357 101.643 353 102.5 353C103.357 353 104 352.357 104 351.5C104 350.643 103.357 350 102.5 350C101.643 350.107 101 350.75 101 351.5Z",
    fill: "url(#paint107_linear)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.1 278.2C67.5146 278.2 79.2 266.515 79.2 252.1C79.2 237.685 67.5146 226 53.1 226C38.6854 226 27 237.685 27 252.1C27 266.515 38.6854 278.2 53.1 278.2Z",
    fill: "url(#paint108_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.1008 267.4C61.5507 267.4 68.4008 260.55 68.4008 252.1C68.4008 243.65 61.5507 236.8 53.1008 236.8C44.6508 236.8 37.8008 243.65 37.8008 252.1C37.8008 260.55 44.6508 267.4 53.1008 267.4Z",
    fill: "url(#paint109_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.1008 261.9C58.5132 261.9 62.9008 257.512 62.9008 252.1C62.9008 246.687 58.5132 242.3 53.1008 242.3C47.6884 242.3 43.3008 246.687 43.3008 252.1C43.3008 257.512 47.6884 261.9 53.1008 261.9Z",
    fill: "url(#paint110_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.9008 252.1C58.9008 255.3 56.3008 257.9 53.1008 257.9C49.9008 257.9 47.3008 255.3 47.3008 252.1C47.3008 248.9 49.9008 246.3 53.1008 246.3C56.3008 246.3 58.9008 248.9 58.9008 252.1Z",
    fill: "url(#paint111_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54 253H53V389H54V253Z",
    fill: "url(#paint112_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 252.5C52 253.357 52.6428 254 53.5 254C54.3571 254 55 253.357 55 252.5C55 251.643 54.3571 251 53.5 251C52.6428 251.107 52 251.75 52 252.5Z",
    fill: "url(#paint113_linear)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.1 255.2C45.5146 255.2 57.2 243.515 57.2 229.1C57.2 214.685 45.5146 203 31.1 203C16.6854 203 5 214.685 5 229.1C5 243.515 16.6854 255.2 31.1 255.2Z",
    fill: "url(#paint114_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.1008 244.4C39.5507 244.4 46.4008 237.55 46.4008 229.1C46.4008 220.65 39.5507 213.8 31.1008 213.8C22.6508 213.8 15.8008 220.65 15.8008 229.1C15.8008 237.55 22.6508 244.4 31.1008 244.4Z",
    fill: "url(#paint115_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.1008 238.9C36.5132 238.9 40.9008 234.512 40.9008 229.1C40.9008 223.687 36.5132 219.3 31.1008 219.3C25.6884 219.3 21.3008 223.687 21.3008 229.1C21.3008 234.512 25.6884 238.9 31.1008 238.9Z",
    fill: "url(#paint116_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.9008 229.1C36.9008 232.3 34.3008 234.9 31.1008 234.9C27.9008 234.9 25.3008 232.3 25.3008 229.1C25.3008 225.9 27.9008 223.3 31.1008 223.3C34.3008 223.3 36.9008 225.9 36.9008 229.1Z",
    fill: "url(#paint117_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32 230H31V366H32V230Z",
    fill: "url(#paint118_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 229.5C30 230.357 30.6428 231 31.5 231C32.3571 231 33 230.357 33 229.5C33 228.643 32.3571 228 31.5 228C30.6428 228.107 30 228.75 30 229.5Z",
    fill: "url(#paint119_linear)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.1 117.2C144.515 117.2 156.2 105.515 156.2 91.1C156.2 76.6854 144.515 65 130.1 65C115.685 65 104 76.6854 104 91.1C104 105.515 115.685 117.2 130.1 117.2Z",
    fill: "url(#paint120_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.101 106.4C138.551 106.4 145.401 99.5498 145.401 91.0998C145.401 82.6498 138.551 75.7998 130.101 75.7998C121.651 75.7998 114.801 82.6498 114.801 91.0998C114.801 99.5498 121.651 106.4 130.101 106.4Z",
    fill: "url(#paint121_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.101 100.9C135.513 100.9 139.901 96.5122 139.901 91.0998C139.901 85.6874 135.513 81.2998 130.101 81.2998C124.688 81.2998 120.301 85.6874 120.301 91.0998C120.301 96.5122 124.688 100.9 130.101 100.9Z",
    fill: "url(#paint122_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.901 91.0998C135.901 94.2998 133.301 96.8998 130.101 96.8998C126.901 96.8998 124.301 94.2998 124.301 91.0998C124.301 87.8998 126.901 85.2998 130.101 85.2998C133.301 85.2998 135.901 87.8998 135.901 91.0998Z",
    fill: "url(#paint123_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.669 91.8999H129.602V403.536H130.669V91.8999Z",
    fill: "url(#paint124_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.602 91.3999C128.602 92.2571 129.244 92.8999 130.102 92.8999C130.959 92.8999 131.602 92.2571 131.602 91.3999C131.602 90.5428 130.959 89.8999 130.102 89.8999C129.244 90.007 128.602 90.6499 128.602 91.3999Z",
    fill: "url(#paint125_linear)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1 58.2C51.5146 58.2 63.2 46.5146 63.2 32.1C63.2 17.6854 51.5146 6 37.1 6C22.6854 6 11 17.6854 11 32.1C11 46.5146 22.6854 58.2 37.1 58.2Z",
    fill: "url(#paint126_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1008 47.3998C45.5507 47.3998 52.4008 40.5498 52.4008 32.0998C52.4008 23.6498 45.5507 16.7998 37.1008 16.7998C28.6508 16.7998 21.8008 23.6498 21.8008 32.0998C21.8008 40.5498 28.6508 47.3998 37.1008 47.3998Z",
    fill: "url(#paint127_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.1008 41.8998C42.5132 41.8998 46.9008 37.5122 46.9008 32.0998C46.9008 26.6874 42.5132 22.2998 37.1008 22.2998C31.6884 22.2998 27.3008 26.6874 27.3008 32.0998C27.3008 37.5122 31.6884 41.8998 37.1008 41.8998Z",
    fill: "url(#paint128_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.9008 32.0998C42.9008 35.2998 40.3008 37.8998 37.1008 37.8998C33.9008 37.8998 31.3008 35.2998 31.3008 32.0998C31.3008 28.8998 33.9008 26.2998 37.1008 26.2998C40.3008 26.2998 42.9008 28.8998 42.9008 32.0998Z",
    fill: "url(#paint129_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.6688 32.8999H36.6016V344.536H37.6688V32.8999Z",
    fill: "url(#paint130_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6016 32.3999C35.6016 33.2571 36.2444 33.8999 37.1015 33.8999C37.9587 33.8999 38.6016 33.2571 38.6016 32.3999C38.6016 31.5428 37.9587 30.8999 37.1015 30.8999C36.2444 31.007 35.6016 31.6499 35.6016 32.3999Z",
    fill: "url(#paint131_linear)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.1 82.2C151.515 82.2 163.2 70.5146 163.2 56.1C163.2 41.6854 151.515 30 137.1 30C122.685 30 111 41.6854 111 56.1C111 70.5146 122.685 82.2 137.1 82.2Z",
    fill: "url(#paint132_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.101 71.3998C145.551 71.3998 152.401 64.5498 152.401 56.0998C152.401 47.6498 145.551 40.7998 137.101 40.7998C128.651 40.7998 121.801 47.6498 121.801 56.0998C121.801 64.5498 128.651 71.3998 137.101 71.3998Z",
    fill: "url(#paint133_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.101 65.8998C142.513 65.8998 146.901 61.5122 146.901 56.0998C146.901 50.6874 142.513 46.2998 137.101 46.2998C131.688 46.2998 127.301 50.6874 127.301 56.0998C127.301 61.5122 131.688 65.8998 137.101 65.8998Z",
    fill: "url(#paint134_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.901 56.0998C142.901 59.2998 140.301 61.8998 137.101 61.8998C133.901 61.8998 131.301 59.2998 131.301 56.0998C131.301 52.8998 133.901 50.2998 137.101 50.2998C140.301 50.2998 142.901 52.8998 142.901 56.0998Z",
    fill: "url(#paint135_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M140.669 59.8999H139.602V371.536H140.669V59.8999Z",
    fill: "url(#paint136_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.602 59.3999C138.602 60.2571 139.244 60.8999 140.102 60.8999C140.959 60.8999 141.602 60.2571 141.602 59.3999C141.602 58.5428 140.959 57.8999 140.102 57.8999C139.244 58.007 138.602 58.6499 138.602 59.3999Z",
    fill: "url(#paint137_linear)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.1 144.2C123.515 144.2 135.2 132.515 135.2 118.1C135.2 103.685 123.515 92 109.1 92C94.6854 92 83 103.685 83 118.1C83 132.515 94.6854 144.2 109.1 144.2Z",
    fill: "url(#paint138_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.101 133.4C117.551 133.4 124.401 126.55 124.401 118.1C124.401 109.65 117.551 102.8 109.101 102.8C100.651 102.8 93.8008 109.65 93.8008 118.1C93.8008 126.55 100.651 133.4 109.101 133.4Z",
    fill: "url(#paint139_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.101 127.9C114.513 127.9 118.901 123.512 118.901 118.1C118.901 112.687 114.513 108.3 109.101 108.3C103.688 108.3 99.3008 112.687 99.3008 118.1C99.3008 123.512 103.688 127.9 109.101 127.9Z",
    fill: "url(#paint140_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.901 118.1C114.901 121.3 112.301 123.9 109.101 123.9C105.901 123.9 103.301 121.3 103.301 118.1C103.301 114.9 105.901 112.3 109.101 112.3C112.301 112.3 114.901 114.9 114.901 118.1Z",
    fill: "url(#paint141_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.669 118.9H108.602V430.536H109.669V118.9Z",
    fill: "url(#paint142_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.602 118.4C107.602 119.257 108.244 119.9 109.102 119.9C109.959 119.9 110.602 119.257 110.602 118.4C110.602 117.543 109.959 116.9 109.102 116.9C108.244 117.007 107.602 117.65 107.602 118.4Z",
    fill: "url(#paint143_linear)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.1 331.2C85.5146 331.2 97.2 319.515 97.2 305.1C97.2 290.685 85.5146 279 71.1 279C56.6854 279 45 290.685 45 305.1C45 319.515 56.6854 331.2 71.1 331.2Z",
    fill: "url(#paint144_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.1008 320.4C79.5507 320.4 86.4008 313.55 86.4008 305.1C86.4008 296.65 79.5507 289.8 71.1008 289.8C62.6508 289.8 55.8008 296.65 55.8008 305.1C55.8008 313.55 62.6508 320.4 71.1008 320.4Z",
    fill: "url(#paint145_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.1008 314.9C76.5132 314.9 80.9008 310.512 80.9008 305.1C80.9008 299.687 76.5132 295.3 71.1008 295.3C65.6884 295.3 61.3008 299.687 61.3008 305.1C61.3008 310.512 65.6884 314.9 71.1008 314.9Z",
    fill: "url(#paint146_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.9008 305.1C76.9008 308.3 74.3008 310.9 71.1008 310.9C67.9008 310.9 65.3008 308.3 65.3008 305.1C65.3008 301.9 67.9008 299.3 71.1008 299.3C74.3008 299.3 76.9008 301.9 76.9008 305.1Z",
    fill: "url(#paint147_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72 306H71V383H72V306Z",
    fill: "url(#paint148_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6016 305.4C69.6016 306.257 70.2444 306.9 71.1015 306.9C71.9587 306.9 72.6016 306.257 72.6016 305.4C72.6016 304.543 71.9587 303.9 71.1015 303.9C70.2444 304.007 69.6016 304.65 69.6016 305.4Z",
    fill: "url(#paint149_linear)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.1 345.2C125.515 345.2 137.2 333.515 137.2 319.1C137.2 304.685 125.515 293 111.1 293C96.6854 293 85 304.685 85 319.1C85 333.515 96.6854 345.2 111.1 345.2Z",
    fill: "url(#paint150_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.101 334.4C119.551 334.4 126.401 327.55 126.401 319.1C126.401 310.65 119.551 303.8 111.101 303.8C102.651 303.8 95.8008 310.65 95.8008 319.1C95.8008 327.55 102.651 334.4 111.101 334.4Z",
    fill: "url(#paint151_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.101 328.9C116.513 328.9 120.901 324.512 120.901 319.1C120.901 313.687 116.513 309.3 111.101 309.3C105.688 309.3 101.301 313.687 101.301 319.1C101.301 324.512 105.688 328.9 111.101 328.9Z",
    fill: "url(#paint152_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.901 319.1C116.901 322.3 114.301 324.9 111.101 324.9C107.901 324.9 105.301 322.3 105.301 319.1C105.301 315.9 107.901 313.3 111.101 313.3C114.301 313.3 116.901 315.9 116.901 319.1Z",
    fill: "url(#paint153_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112 320H111V372H112V320Z",
    fill: "url(#paint154_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.602 319.4C109.602 320.257 110.244 320.9 111.102 320.9C111.959 320.9 112.602 320.257 112.602 319.4C112.602 318.543 111.959 317.9 111.102 317.9C110.244 318.007 109.602 318.65 109.602 319.4Z",
    fill: "url(#paint155_linear)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.1 215.2C118.515 215.2 130.2 203.515 130.2 189.1C130.2 174.685 118.515 163 104.1 163C89.6854 163 78 174.685 78 189.1C78 203.515 89.6854 215.2 104.1 215.2Z",
    fill: "url(#paint156_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.101 204.4C112.551 204.4 119.401 197.55 119.401 189.1C119.401 180.65 112.551 173.8 104.101 173.8C95.6508 173.8 88.8008 180.65 88.8008 189.1C88.8008 197.55 95.6508 204.4 104.101 204.4Z",
    fill: "url(#paint157_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.101 198.9C109.513 198.9 113.901 194.512 113.901 189.1C113.901 183.687 109.513 179.3 104.101 179.3C98.6884 179.3 94.3008 183.687 94.3008 189.1C94.3008 194.512 98.6884 198.9 104.101 198.9Z",
    fill: "url(#paint158_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.901 189.1C109.901 192.3 107.301 194.9 104.101 194.9C100.901 194.9 98.3008 192.3 98.3008 189.1C98.3008 185.9 100.901 183.3 104.101 183.3C107.301 183.3 109.901 185.9 109.901 189.1Z",
    fill: "url(#paint159_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105 190H104V350H105V190Z",
    fill: "url(#paint160_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.602 189.4C102.602 190.257 103.244 190.9 104.102 190.9C104.959 190.9 105.602 190.257 105.602 189.4C105.602 188.543 104.959 187.9 104.102 187.9C103.244 188.007 102.602 188.65 102.602 189.4Z",
    fill: "url(#paint161_linear)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.1 216.2C151.515 216.2 163.2 204.515 163.2 190.1C163.2 175.685 151.515 164 137.1 164C122.685 164 111 175.685 111 190.1C111 204.515 122.685 216.2 137.1 216.2Z",
    fill: "url(#paint162_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.101 205.4C145.551 205.4 152.401 198.55 152.401 190.1C152.401 181.65 145.551 174.8 137.101 174.8C128.651 174.8 121.801 181.65 121.801 190.1C121.801 198.55 128.651 205.4 137.101 205.4Z",
    fill: "url(#paint163_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M137.101 199.9C142.513 199.9 146.901 195.512 146.901 190.1C146.901 184.687 142.513 180.3 137.101 180.3C131.688 180.3 127.301 184.687 127.301 190.1C127.301 195.512 131.688 199.9 137.101 199.9Z",
    fill: "url(#paint164_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.901 190.1C142.901 193.3 140.301 195.9 137.101 195.9C133.901 195.9 131.301 193.3 131.301 190.1C131.301 186.9 133.901 184.3 137.101 184.3C140.301 184.3 142.901 186.9 142.901 190.1Z",
    fill: "url(#paint165_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M138 191H137V351H138V191Z",
    fill: "url(#paint166_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.602 190.4C135.602 191.257 136.244 191.9 137.102 191.9C137.959 191.9 138.602 191.257 138.602 190.4C138.602 189.543 137.959 188.9 137.102 188.9C136.244 189.007 135.602 189.65 135.602 190.4Z",
    fill: "url(#paint167_linear)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.1 131.2C86.5146 131.2 98.2 119.515 98.2 105.1C98.2 90.6854 86.5146 79 72.1 79C57.6854 79 46 90.6854 46 105.1C46 119.515 57.6854 131.2 72.1 131.2Z",
    fill: "url(#paint168_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.1008 120.4C80.5507 120.4 87.4008 113.55 87.4008 105.1C87.4008 96.6498 80.5507 89.7998 72.1008 89.7998C63.6508 89.7998 56.8008 96.6498 56.8008 105.1C56.8008 113.55 63.6508 120.4 72.1008 120.4Z",
    fill: "url(#paint169_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.1008 114.9C77.5132 114.9 81.9008 110.512 81.9008 105.1C81.9008 99.6874 77.5132 95.2998 72.1008 95.2998C66.6884 95.2998 62.3008 99.6874 62.3008 105.1C62.3008 110.512 66.6884 114.9 72.1008 114.9Z",
    fill: "url(#paint170_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.9008 105.1C77.9008 108.3 75.3008 110.9 72.1008 110.9C68.9008 110.9 66.3008 108.3 66.3008 105.1C66.3008 101.9 68.9008 99.2998 72.1008 99.2998C75.3008 99.2998 77.9008 101.9 77.9008 105.1Z",
    fill: "url(#paint171_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73 106H72V384H73V106Z",
    fill: "url(#paint172_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6016 105.4C70.6016 106.257 71.2444 106.9 72.1015 106.9C72.9587 106.9 73.6016 106.257 73.6016 105.4C73.6016 104.543 72.9587 103.9 72.1015 103.9C71.2444 104.007 70.6016 104.65 70.6016 105.4Z",
    fill: "url(#paint173_linear)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "sparks"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.1 72.2C92.5146 72.2 104.2 60.5146 104.2 46.1C104.2 31.6854 92.5146 20 78.1 20C63.6854 20 52 31.6854 52 46.1C52 60.5146 63.6854 72.2 78.1 72.2Z",
    fill: "url(#paint174_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.1008 61.3998C86.5507 61.3998 93.4008 54.5498 93.4008 46.0998C93.4008 37.6498 86.5507 30.7998 78.1008 30.7998C69.6508 30.7998 62.8008 37.6498 62.8008 46.0998C62.8008 54.5498 69.6508 61.3998 78.1008 61.3998Z",
    fill: "url(#paint175_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.1008 55.8998C83.5132 55.8998 87.9008 51.5122 87.9008 46.0998C87.9008 40.6874 83.5132 36.2998 78.1008 36.2998C72.6884 36.2998 68.3008 40.6874 68.3008 46.0998C68.3008 51.5122 72.6884 55.8998 78.1008 55.8998Z",
    fill: "url(#paint176_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M83.9008 46.0998C83.9008 49.2998 81.3008 51.8998 78.1008 51.8998C74.9008 51.8998 72.3008 49.2998 72.3008 46.0998C72.3008 42.8998 74.9008 40.2998 78.1008 40.2998C81.3008 40.2998 83.9008 42.8998 83.9008 46.0998Z",
    fill: "url(#paint177_radial)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79 47H78V325H79V47Z",
    fill: "url(#paint178_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6016 46.3999C76.6016 47.2571 77.2444 47.8999 78.1015 47.8999C78.9587 47.8999 79.6016 47.2571 79.6016 46.3999C79.6016 45.5428 78.9587 44.8999 78.1015 44.8999C77.2444 45.007 76.6016 45.6499 76.6016 46.3999Z",
    fill: "url(#paint179_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.1084 79.1665) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.109 79.1673) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.109 79.1673) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.1091 79.1673) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 58.0701,
    y1: 388.864,
    x2: 56.8509,
    y2: 388.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 59.6016,
    y1: 80.9995,
    x2: 56.6016,
    y2: 77.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1084 109.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.109 109.068) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.109 109.068) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1091 109.068) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 36.0701,
    y1: 418.765,
    x2: 34.8509,
    y2: 418.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 37.6016,
    y1: 110.9,
    x2: 34.6016,
    y2: 107.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.108 26.0669) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.109 26.0677) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.109 26.0677) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.109 26.0677) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 104.07,
    y1: 335.765,
    x2: 102.851,
    y2: 335.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 105.602,
    y1: 27.8999,
    x2: 102.602,
    y2: 24.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.108 225.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.109 225.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.109 225.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.109 225.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 117.468,
    y1: 320.958,
    x2: 116.249,
    y2: 320.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 118.602,
    y1: 226.9,
    x2: 115.602,
    y2: 223.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.108 135.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.109 135.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.109 135.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.109 135.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 129.468,
    y1: 409.88,
    x2: 128.249,
    y2: 409.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 131,
    y1: 136.9,
    x2: 128,
    y2: 133.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.1084 189.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.109 189.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.109 189.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.1091 189.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 65.4685,
    y1: 382.915,
    x2: 64.2493,
    y2: 382.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 67,
    y1: 190.9,
    x2: 64,
    y2: 187.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1084 140.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.109 140.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.109 140.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1091 140.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 47.3747,
    y1: 384.972,
    x2: 46.1555,
    y2: 384.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 49,
    y1: 142,
    x2: 46,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1084 158.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.109 158.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.109 158.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.1091 158.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 28.3747,
    y1: 402.972,
    x2: 27.1555,
    y2: 402.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 30,
    y1: 160,
    x2: 27,
    y2: 157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1084 201.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.109 201.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.109 201.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1091 201.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 39.3747,
    y1: 445.972,
    x2: 38.1555,
    y2: 445.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 41,
    y1: 203,
    x2: 38,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1084 66.0669) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.109 66.0667) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.109 66.0667) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1091 66.0667) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 26.3747,
    y1: 310.972,
    x2: 25.1555,
    y2: 310.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 28,
    y1: 68,
    x2: 25,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.108 164.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.109 164.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.109 164.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.109 164.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 123.375,
    y1: 408.972,
    x2: 122.156,
    y2: 408.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 125,
    y1: 166,
    x2: 122,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.1084 79.0669) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.109 79.0667) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.109 79.0667) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.1091 79.0667) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 99.3747,
    y1: 323.972,
    x2: 98.1577,
    y2: 323.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 101,
    y1: 81,
    x2: 98,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.1084 230.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.109 230.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.109 230.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.1091 230.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 79.3747,
    y1: 333.988,
    x2: 78.158,
    y2: 333.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 81,
    y1: 232,
    x2: 78,
    y2: 229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.1084 141.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.109 141.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.109 141.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.1091 141.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 86.3747,
    y1: 385.972,
    x2: 85.1577,
    y2: 385.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 88,
    y1: 143,
    x2: 85,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.1084 278.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.109 278.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.109 278.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.1091 278.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 95.3747,
    y1: 378.988,
    x2: 94.158,
    y2: 378.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: 97,
    y1: 280,
    x2: 94,
    y2: 277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.108 282.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.109 282.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.109 282.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.109 282.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear",
    x1: 124.375,
    y1: 353.992,
    x2: 123.158,
    y2: 353.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear",
    x1: 126,
    y1: 284,
    x2: 123,
    y2: 281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.1084 341.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.109 341.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.109 341.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.1091 341.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear",
    x1: 59.3747,
    y1: 388.995,
    x2: 58.1595,
    y2: 388.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear",
    x1: 61,
    y1: 343,
    x2: 58,
    y2: 340,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.108 351.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.109 351.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.109 351.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.109 351.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear",
    x1: 102.375,
    y1: 376.997,
    x2: 101.164,
    y2: 376.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear",
    x1: 104,
    y1: 353,
    x2: 101,
    y2: 350,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1084 252.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.109 252.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.109 252.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1091 252.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear",
    x1: 53.3747,
    y1: 388.984,
    x2: 52.1578,
    y2: 388.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear",
    x1: 55,
    y1: 254,
    x2: 52,
    y2: 251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1084 229.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.109 229.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.109 229.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1091 229.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear",
    x1: 31.3747,
    y1: 365.984,
    x2: 30.1578,
    y2: 365.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6826",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FC6076",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear",
    x1: 33,
    y1: 231,
    x2: 30,
    y2: 228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.108 91.0669) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.109 91.0667) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.109 91.0667) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.109 91.0667) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear",
    x1: 130.001,
    y1: 403.5,
    x2: 128.704,
    y2: 403.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear",
    x1: 131.602,
    y1: 92.8999,
    x2: 128.602,
    y2: 89.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1084 32.0669) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.109 32.0667) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.109 32.0667) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1091 32.0667) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear",
    x1: 37.0015,
    y1: 344.5,
    x2: 35.7045,
    y2: 344.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear",
    x1: 38.6016,
    y1: 33.8999,
    x2: 35.6016,
    y2: 30.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.108 56.0669) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.109 56.0667) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.109 56.0667) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.109 56.0667) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear",
    x1: 140.001,
    y1: 371.5,
    x2: 138.704,
    y2: 371.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear",
    x1: 141.602,
    y1: 60.8999,
    x2: 138.602,
    y2: 57.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.108 118.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.109 118.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.109 118.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.109 118.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear",
    x1: 109.001,
    y1: 430.5,
    x2: 107.704,
    y2: 430.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear",
    x1: 110.602,
    y1: 119.9,
    x2: 107.602,
    y2: 116.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.1084 305.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.109 305.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.109 305.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.1091 305.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear",
    x1: 71.3747,
    y1: 382.991,
    x2: 70.1597,
    y2: 382.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear",
    x1: 72.6016,
    y1: 306.9,
    x2: 69.6016,
    y2: 303.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.108 319.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.109 319.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.109 319.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.109 319.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear",
    x1: 111.375,
    y1: 371.994,
    x2: 110.16,
    y2: 371.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear",
    x1: 112.602,
    y1: 320.9,
    x2: 109.602,
    y2: 317.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.108 189.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.109 189.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.109 189.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.109 189.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear",
    x1: 104.375,
    y1: 349.981,
    x2: 103.159,
    y2: 349.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear",
    x1: 105.602,
    y1: 190.9,
    x2: 102.602,
    y2: 187.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.108 190.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.109 190.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.109 190.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.109 190.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear",
    x1: 137.375,
    y1: 350.981,
    x2: 136.159,
    y2: 350.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear",
    x1: 138.602,
    y1: 191.9,
    x2: 135.602,
    y2: 188.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.1084 105.067) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.109 105.067) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.109 105.067) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.1091 105.067) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear",
    x1: 72.3747,
    y1: 383.968,
    x2: 71.1594,
    y2: 383.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear",
    x1: 73.6016,
    y1: 106.9,
    x2: 70.6016,
    y2: 103.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.1084 46.0669) scale(26.0678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.109 46.0667) scale(15.3097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.109 46.0667) scale(9.79269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.1091 46.0667) scale(5.75119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear",
    x1: 78.3747,
    y1: 324.968,
    x2: 77.1594,
    y2: 324.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#FF4D66",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear",
    x1: 79.6016,
    y1: 47.8999,
    x2: 76.6016,
    y2: 44.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF4D66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6826"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlkimaErfolgsgeschichteBwOnlineShopRaketeStartSterne);
export default __webpack_public_path__ + "static/media/alkima-erfolgsgeschichte-bw-online-shop-rakete-start-sterne.f43b4d7c5800306252305170fa37baaa.svg";
export { ForwardRef as ReactComponent };